/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import {
  Space,
  Button,
  Card,
  Popconfirm,
  Layout,
  Table,
  Input,
  Select,
  Drawer,
  Spin,
} from "antd";
import {
  ALL_CAREER_QRY,
  BACKEND_BASE_URL,
  DELETE_CAREER_QRY,
  UPDATE_CAREER_QRY,
} from "../../constants/api";
import { isSuperAdmin } from "../../constants/constent";

function CareersQueryTable() {
  const { Content } = Layout;
  const { Option } = Select;

  const [state, setState] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  // Status Modal
  const [statusUpdating, setStatusUpdating] = useState(false);

  // Resume Drawer
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [resumeUrl, setResumeUrl] = useState("");

  useLayoutEffect(() => {
    getList();
  }, []);

  const getList = () => {
    setLoading(true);
    const successFn = (data) => {
      if (data.status === true) {
        setLoading(false);
        const fetchedData = data.data.map((row, index) => ({
          key: index,
          id: index + 1,
          email: row.email,
          name: row.name,
          phone: row.phone,
          message: row.message,
          resume: row.resume,
          status: (
            <Select
              loading={statusUpdating}
              disabled={statusUpdating}
              value={row.status}
              onChange={(val) => updateStatus(row, val)}
              style={{ width: "100%" }}
            >
              <Option value={0}>Pending</Option>
              <Option value={1}>Reviewed</Option>
              <Option value={2}>Shortlisted</Option>
              <Option value={3}>Rejected</Option>
              <Option value={4}>Interview Scheduled</Option>
              <Option value={5}>Hired</Option>
            </Select>
          ),
          action: (
            <Space>
              {row.resume && (
                <Button onClick={() => openResumeDrawer(row.resume)}>
                  View Resume
                </Button>
              )}
              <Popconfirm
                title="Delete the record"
                description="Are you sure you want to delete this record?"
                onConfirm={() => deleteData(row.id)}
                okText="Yes"
                cancelText="No"
              >
                <Button danger>Delete</Button>
              </Popconfirm>
            </Space>
          ),
        }));
        setState(fetchedData);
        setFilteredData(fetchedData);
      } else {
        setState([]);
        setFilteredData([]);
        setLoading(false);
      }
    };

    const errorFn = () => {
      setState([]);
      setFilteredData([]);
      setLoading(false);
    };

    getAPI(ALL_CAREER_QRY, successFn, errorFn, {});
  };

  const deleteData = (id) => {
    setLoading(true);
    const data = { id };
    postAPI(
      DELETE_CAREER_QRY,
      data,
      (data) => {
        setLoading(false);
        if (data.status) {
          getList();
          displayMessage(SUCCESS_MESSAGE, data.message);
        } else {
          displayMessage(ERROR_MSG_TYPE, data.message);
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
      }
    );
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter((data) =>
      data.email.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const updateStatus = (selectedCareer, newStatus) => {
    if (selectedCareer === null) return;
    setStatusUpdating(true);
    postAPI(
      UPDATE_CAREER_QRY,
      { ...selectedCareer, status: newStatus },
      (data) => {
        setStatusUpdating(false);
        if (data.status) {
          displayMessage(SUCCESS_MESSAGE, data.message);
          getList();
        } else {
          displayMessage(ERROR_MSG_TYPE, data.message);
        }
      },
      () => {
        setStatusUpdating(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to update status");
      }
    );
  };

  const openResumeDrawer = (url) => {
    setResumeUrl(url);
    setDrawerVisible(true);
  };

  const columns = [
    { title: "Sno", dataIndex: "id" },
    { title: "Name", dataIndex: "name" },
    { title: "Email", dataIndex: "email" },
    { title: "Phone", dataIndex: "phone" },
    { title: "Message", dataIndex: "message" },
    { title: "Status", dataIndex: "status" },
    isSuperAdmin() ? { title: "Action", dataIndex: "action" } : null,
  ].filter(Boolean);

  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Career Applications"
            extra={
              <Space>
                <Input
                  placeholder="Search by email"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 300 }}
                />
              </Space>
            }
            bordered={true}
          >
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 800 }}
            />
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>

      {/* Resume Drawer */}
      <Drawer
        title="Resume Preview"
        placement="right"
        width={1200}
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
      >
        {resumeUrl ? (
          <iframe
            src={BACKEND_BASE_URL + "/storage/" + resumeUrl}
            title="Resume Preview"
            style={{ width: "100%", height: "100%" }}
          />
        ) : (
          <Spin />
        )}
      </Drawer>
    </>
  );
}

export default CareersQueryTable;
